module.exports = __webpack_public_path__ + "img/wave_bottom_page.6662f11b.png";